import { getArtistsWithRolePlacement } from 'middleware/track/artistsWithRolePlacement';
import { RELEASE_TYPE } from 'services/music-product-digital/types/enums';
import { IMusicProductPhysicalForm } from 'services/music-product-physical/types/form';
import { IMusicProductPhysicalMutation } from 'services/music-product-physical/types/mutation';
import { unknownEnumValueConverter } from 'utils/global/valueConverter.utils';
import { convertAlbumsModelToTracks } from './albumsToTracks';
import { settlementInfoFormToQuery } from './settlementInfoFormToQuery';

export const musicProductPhysicalFormToQuery = (
  musicProductPhysicalForm: IMusicProductPhysicalForm
): IMusicProductPhysicalMutation => {
  const {
    file,
    productImageLink,
    productImagePreviewLink,
    ...musicProductPhysical
  } = {
    ...musicProductPhysicalForm,
    releaseType: unknownEnumValueConverter<RELEASE_TYPE>(
      musicProductPhysicalForm.releaseType
    ),
    genre: unknownEnumValueConverter<number>(musicProductPhysicalForm.genre.id),
    ean:
      musicProductPhysicalForm.ean !== null
        ? `${musicProductPhysicalForm.ean}`
        : null,
    cLine: !!musicProductPhysicalForm.cLine?.name
      ? musicProductPhysicalForm.cLine
      : null,
    pLine: !!musicProductPhysicalForm.pLine?.name
      ? musicProductPhysicalForm.pLine
      : null,
    tracks: convertAlbumsModelToTracks(musicProductPhysicalForm.tracks),
    artists: getArtistsWithRolePlacement(musicProductPhysicalForm.artists),
    releaseDate: !!musicProductPhysicalForm.releaseDate.length
      ? new Date(musicProductPhysicalForm.releaseDate).toISOString()
      : null,
    settlementInfo:
      (!musicProductPhysicalForm.settlementInfo.perTrackSettlement &&
        musicProductPhysicalForm.settlementInfo.contracts.length) ||
      (!!musicProductPhysicalForm.settlementInfo.perTrackSettlement &&
        musicProductPhysicalForm.settlementInfo.perTrackContracts.length)
        ? settlementInfoFormToQuery(musicProductPhysicalForm.settlementInfo)
        : null,
  };
  return musicProductPhysical;
};
